import { useState } from 'preact/hooks';
import { Product } from '../../../models/Product';
import './ProductImageCarousel.less';
import IconButton from '../../button/IconButton';
import useAppSelector from '../../../hooks/useAppSelector';
import emptyImage from '../../../img/empty-image.svg';
import ProductImage from '../product-image/ProductImage';

export type ProductImageCarouselProps = {
    className?: string;
    product: Product;
    maxItems?: number;
    children?: unknown;
    chips?: unknown;
    disableInteraction?: boolean;
    onClick?: (event: MouseEvent) => void;
};

const ProductImageCarousel = ({
    className = '',
    product,
    maxItems = 10,
    children,
    chips,
    disableInteraction = false,
    onClick
}: ProductImageCarouselProps) => {
    const [visibleIndex, setVisibleIndex] = useState(0);
    if (maxItems > product.images.length) {
        maxItems = product.images.length;
    }
    const aspectRatio = useAppSelector(state => state.uiState.aspectRatio);
    return (
        <div
            data-bri-image-carousel-product-id={product.productId}
            className={`bri-ProductImageCarousel ${className} ${
                onClick ? 'bri-clickable' : ''
            }`}
            style={{ aspectRatio }}
            onClick={onClick}
        >
            {product.images.length === 0 && (
                <div
                    className="bri-ProductImageCarousel-empty"
                    style={{ aspectRatio }}
                >
                    <img src={emptyImage} />
                </div>
            )}
            {product.images.slice(0, maxItems).map((image, index) => (
                <ProductImage
                    key={image.url}
                    isVisible={visibleIndex === index}
                    image={image}
                    defaultWidth={300}
                    aspectRatio={aspectRatio}
                />
            ))}
            {chips && (
                <div className="bri-ProductImageCarousel-chips">{chips}</div>
            )}
            {!disableInteraction && product.images.length > 1 && (
                <div className={`bri-ProductImageCarousel-nav-container`}>
                    <IconButton
                        variant="light"
                        iconId="chevron-left"
                        onClick={event => {
                            event.stopPropagation();
                            event.preventDefault();
                            setVisibleIndex(
                                (maxItems + visibleIndex - 1) % maxItems
                            );
                        }}
                    />
                    <IconButton
                        variant="light"
                        iconId="chevron-right"
                        onClick={event => {
                            event.stopPropagation();
                            event.preventDefault();
                            setVisibleIndex((visibleIndex + 1) % maxItems);
                        }}
                    />
                </div>
            )}
            {children}
        </div>
    );
};

export default ProductImageCarousel;
